export default {
  create_title: 'Lisää webhook-päätepiste',
  edit_title: 'Muokkaa webhook-päätepistettä',
  form: {
    url: 'HTTPS-päätepisteen URL',
    description: 'Kuvaus',
    description_placeholder: 'esim. Tilaustapahtumat kassajärjestelmälle',
    events: 'Toimitettavat tapahtumat',
    events_required: 'Valitse vähintään yksi tapahtuma.',
    events_hint: 'Vain valitut tapahtumat toimitetaan tähän päätepisteeseen.',
    events_selected: '{{selected}}/{{total}}',
    event_groups: {
      order: 'Tilaukset',
      store: 'Myymälä',
      product: 'Tuotteet',
      modifier: 'Muokkaimet',
      menu_push: 'Valikon päivitykset',
      payout: 'Tilitykset',
    },
    status: 'Tila',
    status_active: 'Aktiivinen',
    status_disabled: 'Poistettu käytöstä',
    status_auto_disabled: 'Poistettu käytöstä automaattisesti (valitse Aktiivinen ottaaksesi uudelleen käyttöön)',
  },
  buttons: {
    cancel: 'Peruuta',
    create: 'Luo',
    save: 'Tallenna',
  },
  toasts: {
    created: 'Päätepiste luotu.',
    updated: 'Päätepiste päivitetty.',
    error: 'Päätepistettä ei voitu tallentaa. Yritä uudelleen.',
  },
};
